import React from 'react';
import PropTypes from 'prop-types';
import Button from '@Components/Button';
import { StructureOptionsBadges } from '@Containers/StructureOptions';
import { QUICK_SEARCH_STRUCTURE_UID } from '../../../QuickSearchConstants';

import './BuildQueryStructureDrawing.custom.scss';
import './BuildQueryStructureDrawing.theme.scss';

function BuildQueryStructureDrawing(props) {
  const { structurePreview, clearStructure, previewSize, goToStructure } = props;
  const handleClear = (e) => {
    e.stopPropagation();
    clearStructure();
  };
  return (
    <div className="build-query-structure-drawing">
      {!structurePreview && (
        <Button
          type="button"
          tabIndex="0"
          onClick={goToStructure}
          buttonConfig={{
            type: 'tertiary',
            size: 'sm',
            label: 'Draw',
            ariaLabel: 'Draw quick search structure',
            e2eName: 'build-query-structureDrawing-draw',
          }}
          iconConfig={{
            position: 'before',
            name: 'structure-draw',
            size: 'Sm',
          }}
        />
      )}
      {structurePreview && (
        <div>
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
          <div className="build-query-structure-drawing__structure" onClick={goToStructure}>
            <Button
              type="button"
              tabIndex="0"
              onClick={handleClear}
              buttonConfig={{
                className: 'build-query-structure-drawing__structure_clearButton',
                type: 'link',
                size: 'sm',
                e2eName: 'build-query-structureDrawing-clear',
                ariaLabel: 'Clear quick search structure',
              }}
              iconConfig={{
                name: 'delete',
                size: 'sm',
              }}
            />
            <img
              className="build-query-structure-drawing__structure_image"
              width={`${previewSize ? previewSize.width : 200}px`}
              src={structurePreview}
              alt="structure preview"
            />
            <Button
              type="button"
              tabIndex="0"
              buttonConfig={{
                className: 'build-query-structure-drawing__structure_editButton',
                type: 'link',
                size: 'md',
                e2eName: 'build-query-structureDrawing-edit',
                ariaLabel: 'Edit quick search structure',
              }}
              iconConfig={{
                className: 'build-query-structure-drawing__structure_editButton_icon',
                name: 'pencil',
                size: 'md',
              }}
            />
          </div>
          <StructureOptionsBadges id={QUICK_SEARCH_STRUCTURE_UID} />
        </div>
      )}
    </div>
  );
}

BuildQueryStructureDrawing.propTypes = {
  structurePreview: PropTypes.string,
  clearStructure: PropTypes.func.isRequired,
  previewSize: PropTypes.object,
  goToStructure: PropTypes.func.isRequired,
};

export default BuildQueryStructureDrawing;
